<!-- eslint-disable vue/require-component-is -->
<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <div class="d-flex align-items-center gap-2">
      <FormulateSlot name="prefix" :context="context">
        <component
          :is="context.slotComponents.prefix"
          v-if="context.slotComponents.prefix"
          :context="context"
        />
      </FormulateSlot>

      <div class="d-flex">
        <button type="button" class="__btn __btn-decrement" :disabled="isMin" @click="decrement" >
          <i class="__icon icon-fill_minus" />
        </button>

        <input
          v-bind="context.attributes"
          v-model="context.model"
          type="number"
          class="__number-without-spinner"
          novalidate
        />

        <button type="button" class="__btn __button-increment" :disabled="isMax" @click="increment" >
          <i class="__icon icon-fill_plus" />
        </button>
      </div>

      <FormulateSlot name="suffix" :context="context">
        <component
          :is="context.slotComponents.suffix"
          v-if="context.slotComponents.suffix"
          :context="context"
        />
      </FormulateSlot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // TODO: use formulate validation instead of html attributes validation
    // so the default html validation popup is not shown
    isMax() {
      if (this.context.attributes.max === undefined) return false

      return this.context.model >= this.context.attributes.max
    },
    isMin() {
      if (this.context.attributes.min === undefined) return false

      return this.context.model <= this.context.attributes.min
    },
  },
  methods: {
    increment() {
      if (this.isMax) return
      if (this.context.model === '') this.context.model = 0
      this.context.model = Number(this.context.model) + Number(this.context.attributes.step ?? 1)
      this.context.blurHandler()
    },
    decrement() {
      if (this.isMin) return
      if (this.context.model === '') this.context.model = 0
      this.context.model = Number(this.context.model) - Number(this.context.attributes.step ?? 1)
      this.context.blurHandler()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
